<template>
  <div class="zee zee-component">
    <div class="upload-container">
      <!-- 已上传图片显示区域 -->
      <div v-if="imageUrl" class="image-preview">
        <img :src="imageUrl" alt="上传的图片" @click="handlePreview" />
        <a-button
          size="small"
          status="text"
          class="clear-button"
          @click="handleClear"
          :disabled="sudisabled"
        >
          清除
        </a-button>
      </div>

      <!-- 上传按钮区域 -->
      <a-upload
        v-else
        :before-upload="beforeUpload"
        :show-file-list="false"
        :disabled="sudisabled"
        accept="image/png, image/jpeg, image/jpg"
      >
        <template #default>
          <a-button size="small" type="primary">
            <icon-upload />上传图片
          </a-button>
        </template>
      </a-upload>
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal
      v-model:visible="previewVisible"
      title="图片预览"
      unmount-on-close
      @cancel="handleCancelPreview"
    >
      <template #footer></template>
      <img alt="预览" :src="imageUrl" class="preview-img" />
    </a-modal>
  </div>
</template>

<script>
import { IconUpload } from '@arco-design/web-vue/es/icon'

export default {
  name: 'FImageToBase64',
  components: {
    IconUpload
  },
  props: {
    // 字段名（用于通知父组件更新对应字段）
    name: {
      type: String,
      required: true,
    },
    // 父组件传入的Base64值（用于编辑时回显）
    value: {
      type: String,
      default: '',
    },
    // 是否禁用
    sudisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 用于在组件内显示图片的URL（可以是Base64或远程URL）
      imageUrl: this.value,
      // 图片预览弹窗的可见性
      previewVisible: false,
    };
  },
  watch: {
    // 监听父组件传入的value变化，用于编辑表单时的回显
    value: {
      handler(newVal) {
        this.imageUrl = newVal;
      },
      immediate: true, // 初始化时立即执行
    },
  },
  methods: {
    /**
     * 在文件上传前进行校验
     * @param {File} file - 上传的文件对象
     */
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('请上传图片文件!');
        return false; // 阻止上传
      }

      const isPngJpg = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
      if (!isPngJpg) {
        this.$message.error('图片格式必须是 PNG 或 JPEG/JPG!');
        return false; // 阻止上传
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false; // 阻止上传
      }

      // 校验通过，开始将文件转换为Base64
      this.convertFileToBase64(file);

      // 必须返回 false，因为我们不希望自动上传文件
      return false;
    },

    /**
     * 将 File 对象转换为 Base64 字符串
     * @param {File} file - 要转换的文件
     */
    convertFileToBase64(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result;
        // 更新组件内部状态
        this.imageUrl = base64String;
        // 通过事件通知父组件
        this.$emit('change', this.name, base64String);
        this.$message.success('图片上传成功并已转换为Base64!');
      };
      reader.onerror = (error) => {
        console.error('文件读取失败:', error);
        this.$message.error('文件读取失败，请重试!');
      };
      reader.readAsDataURL(file);
    },

    /**
     * 清除已上传的图片
     */
    handleClear() {
      this.imageUrl = '';
      this.$emit('change', this.name, '');
    },

    /**
     * 打开图片预览弹窗
     */
    handlePreview() {
      this.previewVisible = true;
    },

    /**
     * 关闭图片预览弹窗
     */
    handleCancelPreview() {
      this.previewVisible = false;
    },
  },
};
</script>

<style scoped>
.upload-container {
  display: flex;
  align-items: center;
}

.image-preview {
  display: flex;
  align-items: center;
}

.image-preview img {
  width: 100px;
  height: auto;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.clear-button {
  color: #f5222d;
  margin-left: 10px;
  cursor: pointer;
}

.preview-img {
  width: 100%;
  max-width: 800px;
  display: block;
  margin: 0 auto;
}
</style>